import React from 'react';

export function SlideFooter({ left_logo_url, right_logo_url, footer_image_url }) {
  return (
    <div className="absolute left-0 right-0 bottom-0">
      {footer_image_url ? (
        <img src={footer_image_url} alt="" className="w-full object-cover" style={{ maxHeight: 64 }} />
      ) : (
        <>
          <div className="border-t border-gray-200" />
          <div className="flex items-center justify-between px-8 py-3">
            {left_logo_url ? <img src={left_logo_url} alt="" className="h-8 object-contain" /> : <span />}
            {right_logo_url ? <img src={right_logo_url} alt="" className="h-8 object-contain" /> : <span />}
          </div>
        </>
      )}
    </div>
  );
}

export const brand = { red: '#D71E1E', blue: '#1E3A8A', grayBand: '#E5E7EB' };

export function PageTitle({ title, subtitle, accentColor }) {
  return (
    <div className="mb-0 ppt-title text-left">
      <div className="grid grid-cols-[6px_1fr] gap-3 items-start">
        <span
          className="block w-1.5 rounded-full self-stretch"
          style={{ backgroundColor: accentColor || '#d1d5db' }}
        />
        <div>
          {title ? (
            subtitle ? (
              <h3 className="font-semibold tracking-tight">{title}</h3>
            ) : (
              <h2 className="font-semibold tracking-tight">{title}</h2>
            )
          ) : null}
          {subtitle ? <div className="ppt-subtitle mt-0 text-left">{subtitle}</div> : null}
        </div>
      </div>
    </div>
  );
}

export function FrameWithStickyTitle({ title, subtitle, children, accentColor }) {
  return (
    <div className="ppt-container overflow-hidden">
      <div className="ppt-frame-header sticky top-0 z-10 bg-white/90 backdrop-blur max-h-[150px] overflow-hidden">
        <PageTitle title={title} subtitle={subtitle} accentColor={accentColor} />
      </div>
      <div className="ppt-frame-body flex-1 overflow-y-auto overflow-x-hidden flex flex-col">
        {children}
      </div>
    </div>
  );
}

// Reserved for future diagram slide templates
